import React from 'react';
import { Button, Tooltip } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { EntityRemoveButton, Localize } from 'components/service';
import Icons from 'components/icons';
import { useGraphicStandMutation } from '../hooks';

const GraphicStandReturnWarehouseField = ({ graphicStand }) => {
    const {
        _setMutationGraphicStandDelete,
        loadingMutationGraphicStandDelete,
    } = useGraphicStandMutation.delete({ graphicStand });

    if (!graphicStand)
    {
        return <strong>&mdash;</strong>;
    }

    return (
        <EntityRemoveButton
            modalButton={
                <Tooltip title={ <Localize>ACTIONS.Return_To_Warehouse</Localize> } placement="top">
                    <Button
                        type="primary"
                        style={ { width: '70px', minWidth: '70px' } }
                    >
                        <Icons.TruckReverse style={{ fontSize: '30px' }} />
                        <ArrowLeftOutlined style={{ fontSize: '16px', marginTop: '1px' }} />
                    </Button>
                </Tooltip>
            }
            nameEntity={ Localize({ children: "ENTITY.Modal_Title_Stand" }).props.children }
            dataNameEntity={ graphicStand.exhibitor }
            loading={ loadingMutationGraphicStandDelete }
            deleteMutation={ _setMutationGraphicStandDelete }
            variables={ {
                id: graphicStand.id,
            } }
        />
    );
};

export default GraphicStandReturnWarehouseField;
